module.exports = __webpack_public_path__ + "static/SimplonMono-Regular-WebS.116b7ec2.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SimplonMono-Regular-WebS.woff
// module id = 304
// module chunks = 114276838955818